<script>
import Notification from '../../reUse/Notification.vue';
export default {
  components: {
    Notification,
  },
  emits: ['backToAdmin'],
  data() {
    return {
      izbranUserId: '',
      izbranoLetalisce: 'LJAJ',
      izbranoLetalisceId: 5,
      izbraniUpravniki: [],
      uporabniki: [],
      letalisca: [],
      upravniki: [],
      text: '',
      types: '',
      ShowNoti: false,
    }
  },
  mounted() {
    this.GetUporabniki();
    this.GetUpravljalci();
  },
  computed: {},
  methods: {
    GetUporabniki() {
      axios.get('./api/uporabniki/izpis/', {withCredentials: true}).then((response) => {
        this.uporabniki = response.data.uporabniki;
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    GetUpravljalci() {
      axios.post('./api/urednik/letalisca/beri/', {withCredentials: true}).then((response) => {
        this.upravniki = response.data.podatki;
        this.Upravljalci();
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    Upravljalci() {
      for (var i = 0; i < this.upravniki.length; i++) {
        if (this.upravniki[i].icao === this.izbranoLetalisce) {
          this.izbraniUpravniki = this.upravniki[i].upravnik;
          this.izbranoLetalisceId = this.upravniki[i].id;
        }
      }
    },
    OdstraniUpravitelja(id) {
      var upravnik = [];
      var pUpravnik = [];
      for (var i = 0; i < this.izbraniUpravniki.length; i++) {
        if (this.izbraniUpravniki[i].id !== id) {
          upravnik.push(this.izbraniUpravniki[i]);
          pUpravnik.push(this.izbraniUpravniki[i].id);
        }
      }
      this.izbraniUpravniki = upravnik;
      var podatki = new URLSearchParams();
      podatki.append('idLetalisca', this.izbranoLetalisceId);
      podatki.append('upravniki', JSON.stringify(pUpravnik));
      axios.post('./api/urednik/letalisca/uredi/', podatki, {withCredentials: true}).then((response) => {
        this.GetUpravljalci();
        this.text = response.data.sporocilo;
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    Povezi() {
      var pUpravnik = [];
      for (var i = 0; i < this.izbraniUpravniki.length; i++) {
        pUpravnik.push(this.izbraniUpravniki[i].id);
      }
      pUpravnik.push(this.izbranUserId);
      var podatki = new URLSearchParams();
      podatki.append('idLetalisca', this.izbranoLetalisceId);
      podatki.append('upravniki', JSON.stringify(pUpravnik));
      axios.post('./api/urednik/letalisca/uredi/', podatki, {withCredentials: true}).then((response) => {
        this.izbranUserId = '';
        this.GetUpravljalci();
        this.text = response.data.sporocilo;
        this.types = "Uspešno";
        this.ShowNoti = true;
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
  }
}
</script>
<template>
  <!-- <button class="p-2 btn-back" @click.prevent="$emit('backToAdmin')"><i class="fas fa-arrow-up fa-2x"></i></button> -->
  <h5 class="d-flex justify-content-center text-white">Upravljanje upravljalcev letališč</h5>
  <div class="container p-2">
    <div class="col-12">
      <!-- Letališča -->
      <div class="container p-2">
        <div class="label-date col-6 p-2" for="izbranUserId">Letališča</div>
        <select class="input border-0 rounded-4 p-2 fs-5" v-model='izbranoLetalisce' @change.prevent="Upravljalci()">
          <option disabled value=''>Izberi Letališče</option>
          <option :disabled="upravnik.id !== 5 /* hardcoded na LJAJ */" v-for='upravnik in upravniki' :value='upravnik.icao'>{{upravnik.naziv}}</option>
        </select>
      </div>
      <!-- Uporabniki -->
      <div class="container p-2">
        <div class="label-date col-6 p-2" for="izbranUserId">Uporabnik</div>
        <select class="input border-0 rounded-4 p-2 fs-5" v-model='izbranUserId'>
          <option disabled value=''>Izberi uporabnika</option>
          <option v-for='uporabnik in uporabniki' :disabled="this.izbraniUpravniki.some(upravnik => upravnik.id == uporabnik.id)" :value='uporabnik.id'>{{uporabnik.ime}} {{uporabnik.priimek}}</option>
        </select>
      </div>
    </div>
    <div class='col-12'>
      <div class="container p-2">
        <button @click.prevent="Povezi()" class="btn btn-primary rounded-pill btn-add col-12">Dodaj</button>
      </div>
    </div>
    <div class="hr-with-text p-2">UPRAVLJALCI LETALIŠČA {{izbranoLetalisce}}</div>
    <!-- IZPIS UPRAVLJALCI -->
    <div class='col-12'>
      <div class="container row p-2" v-for='upravnik in izbraniUpravniki'>
        <div class="col-10 text-podatki text-manjsi">{{upravnik.email}}</div>
        <div class="col-2 text-podatki text-manjsi"><button class='btn btn-sm btn-outline-danger' @click.prevent="OdstraniUpravitelja(upravnik.id)"><i class="fas fa-trash"></i></button></div>
      </div>
    </div>
  </div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
  </Transition>
</template>